<template>
  <div class="page">
    <FenceAlarm v-if="showAlarmFence" :alarmData="alarmData" @quitModal="quitModal" />
    <InnerFenceAlarm ref="innerFenceArarm" :alarmData="alarmData"  />
    <a-modal :title="$t('global.alarmHandle')" v-model="processModel" :width="'40%'" @cancel="cancelModal" @ok="handleOk">
      <a-form :form="form">
        <a-form-item :label="$t('global.alarmHandle')" v-bind="formItemLayout">
          <a-textarea v-model="annotation"
            v-decorator="['annotation',{ rules: [{ required: true, message: $t('global.alarmHandleDescription') }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>

    <div id='components-form-demo-advanced-search'>
      <z-search-form :searchOption="searchOption" @search="handleSearch"></z-search-form>

      <div class="content" style="padding: 15px">
        <div>
          <a-row type="flex" justify="start" :gutter="8"  style="margin-bottom:15px">
            <a-col>
              <a-button :disabled="selectedRowKeys.length === 0" @click="batchProcess">
                <a-icon type="edit" />
                {{$t('global.dispose')}}
              </a-button>
            </a-col>
            <a-col v-if="isSuperAdmin">
              <a-button  :disabled="selectedRowKeys.length === 0" @click="batchDelete">
                <a-icon type="delete" />
                {{$t('global.delete')}}
              </a-button>
            </a-col>
          </a-row>
          <z-column-check :columnOption="columnOption" ref="columnCheck"></z-column-check>
          <div class="section-list">
            <a-alert :showIcon="true" :message="tips + `     ${isIntegrator ? $t('alarm.integratorTip') : ''} `" type="info" />
          </div>
        </div>

        <div class='section-list'>
          <a-spin :spinning="isLoading" :tip="$t('global.loading')">
            <a-table :rowSelection="rowSelection" :columns="columnOption.listColumns" :dataSource="data" :pagination="pagination"
              @change="onChange">
              <template slot="alarmName" slot-scope="text, record">
                <div>
                  <i class="icon-alarm icon-lg">
                    <zx-icon :type="computedAlarmIcon(record.alarmCode)" />
                  </i>
                  {{$t(`alarm.${text}`)}}
                </div>
              </template>
              <template slot="level" slot-scope="text">
                <a-tag color="blue" v-if="text == 1">{{$t('global.event')}}</a-tag>
                <a-tag color="yellow" v-if="text == 2">{{$t('global.noramlAlarm')}}</a-tag>
                <a-tag color="orange" v-if="text == 3">{{$t('global.importantAlarm')}}</a-tag>
                <a-tag color="red" v-if="text == 4">{{$t('global.fearfulAlarm')}}</a-tag>
              </template>
              <template slot="date" slot-scope="text">
                <span>{{text && timeFormat(text)}}</span>
              </template>
              <template slot="status" slot-scope="text, record">
                <a-tag @click="disposeAlarm(record)" color="red" v-if="text == 0">{{$t('global.undisposed')}}</a-tag>
                <a-tooltip v-if="text == 1" placement="top"  arrowPointAtCenter>
                  <div slot="title">
                    <div class="more-white" v-if="record.optName">{{$t('alarm.optName') + ': '}} <span class="white">{{record.optName}}</span></div>
                    <div class="more-white" v-if="record.confirmTime">{{$t('alarm.confirmTime') + ': '}}<span class="white">{{$moment(record.confirmTime * 1000).format('YYYY-MM-DD hh:mm:ss')}}</span></div>
                    <div class="more-white">{{$t('alarm.annotation') + ': '}}<span class="white">{{record.annotation}}</span></div>
                  </div>
                  <a-tag color="green">{{$t('global.processed')}}</a-tag>
                </a-tooltip>
              </template>
              <template slot="alarmType" slot-scope="text, record">
                <!-- <a-button type="danger" @click="showAlarmInfo(record)" size="small" v-if="text === '围栏告警' || text === 'Fence Alarm'">{{$t('global.showAlarmPosition')}}
                </a-button> -->
                <a-button type="danger" @click="showAlarmInfo(record)" size="small" v-if="record.alarmCode === 31">{{$t('global.showAlarmPosition')}}
                </a-button>
              </template>
            </a-table>
          </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import ZSearchForm from '@/components/common/SearchForm.vue'
  import ZColumnCheck from '@/components/common/ColumnCheck.vue'
  import FenceAlarm from './FenceAlarmModal'
  import InnerFenceAlarm from './InnerFenceAlarmModal.vue'
  import moment from 'moment'
  // import ACol from "ant-design-vue/es/grid/Col";
  import {computedAlarmIcon} from '../../utils/homeFn'
  import {
    mapGetters
  } from 'vuex'
  import bus from '../../bus/bus';

  export default {
    components: {
      // ACol,
      ZSearchForm,
      ZColumnCheck,
      FenceAlarm,
      InnerFenceAlarm
    },
    data() {
      return {
        // 是否显示围栏告警模态框
        showAlarmFence: false,
        // 围栏告警的信息
        alarmData: '',
        // 重要的告警类型
        seriousAlarmType: ['围栏告警', '表带损坏', '开锁告警', '跌倒告警', '表锁授权', '失联告警'],
        form: null,
        processModel: false,
        searchParams: {},
        flag: false,
        searchOption: [{
            key: "sn",
            name: "序列号",
            type: "input",
            placeholder: '请输入序列号SN',
            value: "",
            default: true
          },
          {
            key: "uniqueSign",
            name: "实体",
            placeholder: '请输入实体姓名',
            type: "input",
            value: "",
            default: true
          },
          {
            key: "org",
            name: "所属机构",
            type: "orgChooser",
            matchType: "eq",
            option: {
              showDirect: true,
              directFlag: false,
              value: ""
            }
          },
          {
            key: "status",
            name: "告警状态",
            type: "selector",
            placeholder: '请选择告警状态',
            value: undefined,
            source: [{
                name: '未解决',
                value: 0
              },
              {
                name: '已解决',
                value: 1
              }
            ]
          },
          {
            key: "occurTime",
            name: "告警时间",
            type: "custom",
            matchValue: undefined,
            placeholder: '选择时间',
            dataType: "time",
            searchTypeData: [{
                key: "之后",
                type: "datePicker",
                paramName: "minTime",
                value: null
              },
              {
                key: "之前",
                type: "datePicker",
                paramName: "maxTime",
                value: null
              },
              {
                key: "之间",
                type: "rangePicker",
                paramName: "minTime,maxTime",
                value: []
              }
            ]
          }
        ],
        columnOption: {
          listColumns: [],
          columns: [{
            "title": "alarmType",
            "dataIndex": "alarmType",
            "key": "alarmType",
            "left": true,
            "filters": [],
            "scopedSlots": {
              "customRender": "alarmName"
            }
          }, {
            "title": "alarmLevel",
            "dataIndex": "level",
            "key": "level",
            "left": true,
            "scopedSlots": {
              "customRender": "level"
            }
          }, {
            "title": "serialNumber",
            "dataIndex": "deviceSn",
            "key": "deviceSn",
            "left": true
          }, {
            "title": "name",
            "dataIndex": "uniqueSign",
            "key": "uniqueSign",
            "checkColumn": true,
            "left": true
          }, {
            "title": "deviceOrg",
            "dataIndex": "orgName",
            "key": "orgName",
            "checkColumn": false,
          }, 
          // {
          //   "title": "group",
          //   "dataIndex": "groupName",
          //   "key": "groupName",
          //   "checkColumn": false,
          // },
           {
            "title": "alarmTime",
            "dataIndex": "occurTime",
            "key": "occurTime",
            "checkColumn": true,
            "scopedSlots": {
              "customRender": "date"
            },
            "sorter": true
          }, {
            "title": "alarmStatus",
            "dataIndex": "status",
            "key": "status",
            "checkColumn": true,
            "scopedSlots": {
              "customRender": "status"
            }
          }, {
            "title": "notice",
            "dataIndex": "notice",
            "key": "notice",
            "checkColumn": false,
            // "scopedSlots": {
            //     "customRender": "status"
            // }
          }, {
            "title": "description",
            "dataIndex": "message",
            "key": "message",
            "checkColumn": true,
          }, {
            "title": "operate",
            "dataIndex": "alarmType",
            "key": "alarmType-action",
            "checkColumn": true,
            "scopedSlots": {
              "customRender": "alarmType"
            }
          }, ]
        },
        annotation: null,
        pagination: {
          showSizeChanger: false,
          pageSizeOptions: ['5', '7', '10', '20'],
          pageSize: 10,
          current: 1,
          total: 0,
          showTotal: this.showTotal,
          showQuickJumper: true
        },
        data: [],
        selectedRows: [],
        selectedRowKeys: [],
        formItemLayout: {
          labelCol: {
            lg: {
              span: 24
            },
            xl: {
              span: 4
            }
          },
          wrapperCol: {
            lg: {
              span: 24
            },
            xl: {
              span: 18
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters(['isSuperAdmin', 'isIntegrator']),
      tips() {
        return this.$t('alarm.selectedNum', {num: this.selectedRowKeys.length})
      },
      rowSelection () {
        return {
          fixed: true,
          selectedRowKeys: this.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            // console.log(this.selectedRows)
            // console.log(this.selectedRowKeys)
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.status == 1 ? true : false
            }
          }),
        }
      },
      
    },
    mounted () {
      bus.$on('langChanged', (lang) => {
        // console.log(lang)
        this.$nextTick().then(() => {
            this.$refs["columnCheck"].refresh()
        })
      })
    },
    created() {
      this.getAllAlarmTypes()
      this.pageQuery()
    },
    beforeDestroy () {
      bus.$off('langChanged')
    },
    methods: {
      computedAlarmIcon,
      // 点击处理单条告警
      disposeAlarm(record) {
        // console.log(record)
        this.processModel = true
        this.selectedRows = [record]
        this.selectedRowKeys = [record.key]
        this.batchProcess()
      },
      // 退出处理告警
      cancelModal () {
        this.selectedRows = []
        this.selectedRowKeys = []
      },
      getAllAlarmTypes () {
        // this.$http.get(config.api.get_alarm_types).then((res) => {
        //   // console.log(res)
        //   let {code, result} = res
        //   if (code === 0) {
        //     let filter = result.map((alarm) => {
        //       return {
        //         // text: `
        //         //     <zx-icon :type="${computedAlarmIcon(alarm.code)}" />
        //         //     ${alarm.name}
        //         //   `,
        //         // text: () => {
        //         //   return `
        //         //     <zx-icon :type="${computedAlarmIcon(alarm.code)}" />
        //         //     ${alarm.name}
        //         //   `
        //         // },
        //         text: alarm.name,
        //         value: alarm.code.toString(),
        //         code: alarm.code
        //       }
        //     })
        //     this.columnOption.columns[0].filters = filter
        //     this.$refs["columnCheck"].refresh()
        //   }
        // })
        let filter = [
          {
            text: this.$t(`alarm.设备低电告警`),
            value: '1',
            code: 1
          },
          {
            text: this.$t(`alarm.跌倒告警`),
            value: '20',
            code: 20
          },
          {
            text: this.$t(`alarm.SOS告警`),
            value: '21',
            code: 21
          },
           {
            text: this.$t(`alarm.SOS取消`),
            value: '12',
            code: 12
          },
          {
            text: this.$t(`alarm.表带损坏告警`),
            value: '22',
            code: 22
          },
          {
            text: this.$t(`alarm.异常开锁告警`),
            value: '26',
            code: 26
          },
          {
            text: this.$t(`alarm.围栏告警`),
            value: '31',
            code: 31
          },
          {
            text: this.$t(`alarm.失联告警`),
            value: '10001',
            code: 10001
          },
          {
            text: this.$t(`alarm.心率异常告警`),
            value: '10002',
            code: 10002
          },
          {
            text: this.$t(`alarm.手环佩戴`),
            value: '27',
            code: 27
          },
          {
            text: this.$t(`alarm.手环摘除`),
            value: '28',
            code: 28
          },
          {
            text: this.$t(`alarm.体温异常告警`),
            value: '10006',
            code: 10006
          },
          {
            text: this.$t(`alarm.上班打卡`),
            value: '16',
            code: 16
          },
          {
            text: this.$t(`alarm.下班打卡`),
            value: '17',
            code: 17
          },
           {
            text: this.$t(`alarm.超员告警`),
            value: '10007',
            code: 10007
          },
        ]
        this.columnOption.columns[0].filters = filter
        // this.$refs["columnCheck"].refresh()
      },
      showAlarmInfo(record) {
        // console.log(record.attr)
        // 显示弹出框
        this.alarmData = record
        if(record.scene) {
          this.$refs.innerFenceArarm.showModal()
        } else {
          this.showAlarmFence = true
        }
      },
      quitModal() {
        this.showAlarmFence = false
      },
      handleOk() {
        let _this = this
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            let params = []
            this.selectedRowKeys.map(function (item) {
              let param = {
                id: item,
                annotation: _this.annotation
              }
              params.push(param)
            })
            this.$http.post(config.api.alarm_process_url, params).then((response) => {
              if (response.code == 0) {
                _this.processModel = false
                _this.$message.success(_this.$t('global.successful'))
                _this.pageQuery()
              }
            }).catch((err) => {
              console.log(err)
            })
            _this.selectedRowKeys = []
          }
        })
      },
      batchProcess() {
        this.form = this.$form.createForm(this)
        this.processModel = true
      },
      batchDelete() {
        let _this = this
        this.$confirm({
          title: '确认删除选择的记录吗?',
          onOk() {
            _this.$http.post(config.api.alarm_url, _this.selectedRowKeys).then((response) => {
              if (response.code == 0) {
                _this.$message.success('删除成功')
                _this.pageQuery()
              } else {
                _this.$message.error(response.desc)
              }
            })
            _this.selectedRowKeys = []
          },
          onCancel() {}
        });
      },
      timeFormat(timestamp) {
        return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
      handleSearch(params) {
        if(!this.flag){
            this.flag = true;
            return;
        }
        let alarmCode
        if (this.searchParams.alarmCode && this.searchParams.alarmCode.length > 0) {
          alarmCode = this.searchParams.alarmCode
        }
        this.searchParams = params
        this.searchParams["currentPage"] = 1
        this.selectedRowKeys = []
        if (alarmCode && alarmCode.length > 0) {
          this.searchParams['alarmCode'] = alarmCode
        }
        this.pageQuery()
      },
      pageQuery() {
        this.isLoading = true
        this.searchParams["pageSize"] = this.pagination.pageSize.toString()
        this.searchParams["currentPage"] = this.pagination.current.toString()
        // console.log(this.searchParams)
        this.$http.post(config.api.alarm_all_url, this.searchParams).then((response) => {
          if (response.code == 0) {
            // console.log(response)
            response.result.resultList.map((item) => {
              item.key = item.id
            })
            this.data = response.result.resultList
            this.data.map((item) => { 
              switch(item.alarmCode){
                case 1:
                  const match = item.message.match(/当前设备电量(\d+%)/)
                  const currentBattery = match ? match[1] : ''
                  item.message = this.$t(`alarm.设备低电告警`) + ":" + currentBattery
                  break;
                case 22:
                  item.message = this.$t(`alarm.表带损坏告警`)
                  break;
                case 26:
                  item.message = this.$t(`alarm.异常开锁告警`)
                  break;
                  case 31:
                  item.message = this.$t(`alarm.围栏告警`)
                  break;
                  case 10001:
                  item.message = this.$t(`alarm.失联告警`)
                  break;
                case 10002:
                    let a = item.message.split(':')
                    item.message = this.$t(`alarm.` + a[0]) + ":  " + a[1]
                  break;
                  case 27:
                  item.message = this.$t(`alarm.手环佩戴`)
                  break;
                  case 28:
                  item.message = this.$t(`alarm.手环摘除`)
                  break;
                  case 21:
                  item.message = this.$t(`alarm.SOS告警`)
                  break;
                  case 12:
                  item.message = this.$t(`alarm.SOS取消`)
                  break;
              }
              if(item.uniqueSign.indexOf('(') != -1){
                item.uniqueSign = item.uniqueSign.split('(')[0] + '(' + this.$t(`alarm.人员已删除`) + ")"
              }
            })
            this.pagination.current = response.result.page.currentPage
            // console.log(this.data)
            this.pagination.total = response.result.page.totalSize
          }
          this.isLoading = false
        })
      },
      // onSelectChange(selectedRowKeys, selectedRows) {
      //   this.selectedRowKeys = selectedRowKeys
      //   this.selectedRows = selectedRows
      // },
      onChange(page, filters, sorter) {
        // console.log(filters)
        this.pagination.pageSize = page.pageSize
        this.pagination.current = page.current
        if (sorter.order) {
          this.searchParams['orderBy'] = sorter.field
          if (sorter.order == "ascend") {
            this.searchParams['sort'] = "ASC"
          } else {
            this.searchParams['sort'] = "DESC"
          }
        } else {
          delete this.searchParams["orderBy"]
          delete this.searchParams["sort"]
        }
        if (filters.alarmType && filters.alarmType.length > 0) {
          this.searchParams['alarmCode'] = filters.alarmType
        } else {
          delete this.searchParams['alarmCode']
        }
        this.pageQuery()
      },
      showTotal(total) {
        return this.$t('global.totalRecords', {num: total})
      },
    }
  }
</script>